// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5a-0";
export var eligibilityCardNotEligible = "_5a-1";